<div class="table-container">
    <table class="custom-table">
        <thead>
            <tr>
                <!-- <th *ngIf="tableHeader.isSelectable" class="select-header">
                    <input type="checkbox" class="select-checkbox" (change)="toggleSelectAll()"
                        [checked]="selectStates === 'all'" [indeterminate]="selectStates === 'some'" />
                </th> -->

                <ng-container *ngIf="!tableHeader.isResposive">
                    <th *ngFor="let header of tableHeader.headers" class="table-header-cell">
                        <span class="header-label">
                            {{ header.label | translate }}
                        </span>
                        <img *ngIf="header.isSortable" 
                             [src]="getSortDirection(header) === 'none' ? 'assets/media/general/sort.svg' :
                                    getSortDirection(header) === 'asc' ? 'assets/media/general/sort-down.svg' :
                                    'assets/media/general/sort-down.svg'" 
                             [style.transform]="getSortDirection(header) === 'asc' ? 'rotate(180deg)' : 'none'"
                             alt="Sort" class="sort-icon mx-2"
                            (click)="onSort.emit(header)" />
                    </th>
                </ng-container>

                <ng-container *ngIf="tableHeader.isResposive">
                    <th *ngFor="let header of visibleHeaders" class="table-header-cell">
                        <span class="header-label">
                            {{ header.label | translate }}
                        </span>
                        <img *ngIf="header.isSortable" 
                             [src]="getSortDirection(header) === 'none' ? 'assets/media/general/sort.svg' :
                                    getSortDirection(header) === 'asc' ? 'assets/media/general/sort-down.svg' :
                                    'assets/media/general/sort-down.svg'" 
                             [style.transform]="getSortDirection(header) === 'asc' ? 'rotate(180deg)' : 'none'"
                             alt="Sort" class="sort-icon mx-2"
                            (click)="onSort.emit(header)" />
                    </th>
                    <th *ngIf="hiddenHeaders.length > 0" class="table-header-cell">
                        <span class="header-label"></span>
                    </th>
                </ng-container>
            </tr>
        </thead>

        <tbody>
            <ng-content select="[table-rows]"></ng-content>
        </tbody>
    </table>
</div>